import React, { useEffect, useState } from 'react';
import { DraggableProvided } from 'react-beautiful-dnd';
import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import Select from '@atlaskit/select';
import Textfield from '@atlaskit/textfield';
import { G300, N0 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { TRANSLATIONS, Translations as TranslationsType } from '../../interfaces';
import { Label, SelectDescription } from '../../styles';
import {
    LEVEL_DESCRIPTION_TRANSLATION_KEY,
    LEVEL_NAME_TRANSLATION_KEY,
    TRANSLATION_VALUE_CHANGED,
    TRANSLATIONS_LANGUAGE_SELECT_DESCRIPTION,
} from '../../utils/constants';
import { NonDraggableWrapper } from '../common/NonDraggableWrapper';

import { ValueLabel } from './options-adder/interfaces';
import {
    TranslationFormWrapper,
    TranslationsLanguageLabelWrapper as Wrapper,
    TranslationsWrapper,
} from './options-adder/OptionsAdderStyled';

type Props = {
    translation: Partial<TranslationsType>;
    originalValue: string;
    optionIndex: number;
    locale: string;
    onChange: any; // TODO: daję any, bo nie wiem jak zrobić coś w stylu sygnaturaFunkcji1 | sygnaturaFunkcji2, sypie błędami --> ktoś wie?,
    isLevelNameTranslation?: boolean;
    isInTabContext?: boolean;
    provided?: DraggableProvided;
};

const Translations: React.FC<Props> = ({
    translation,
    originalValue,
    optionIndex,
    locale,
    onChange,
    isLevelNameTranslation = true,
    isInTabContext = true,
    provided,
}) => {
    const [selectedLanguage, setSelectedLanguage] = useState<ValueLabel>({ value: '', label: '' });
    const [languages, setLanguages] = useState<ValueLabel[]>([]);

    const handleLanguageChange = (selected: ValueLabel | null) => setSelectedLanguage(selected!);

    const isOptionTranslated = (language: ValueLabel) =>
        language && translation && !!translation[language.value] && translation[language.value] !== originalValue;

    const FormatLanguageLabel = (option: ValueLabel) => {
        const languageToCheck = languages.find(language => language.value === option.value);
        const isTranslated = isOptionTranslated(languageToCheck!);
        token;

        return (
            <Wrapper>
                {isTranslated && (
                    <CheckCircleIcon
                        primaryColor={token('color.icon.success', G300)}
                        secondaryColor={token('color.background.input.hovered', N0)}
                        label={'translation-exists'}
                    />
                )}
                <span className='label'>{option.label}</span>
            </Wrapper>
        );
    };

    const determineTranslationValue = (
        translation: Partial<TranslationsType>,
        selectedLanguage: ValueLabel,
        optionValue: string
    ): string => {
        if (translation && (translation[selectedLanguage.value] || translation[selectedLanguage.value] === '')) {
            return translation[selectedLanguage.value]!;
        }

        return optionValue;
    };

    const renderTranslationForm = () => (
        <TranslationFormWrapper>
            <Select<ValueLabel>
                placeholder=''
                value={selectedLanguage}
                options={languages}
                onChange={handleLanguageChange}
                formatOptionLabel={FormatLanguageLabel}
                id={`translations-select${optionIndex}`}
            />
            <Textfield
                onChange={(e: React.FormEvent) =>
                    isInTabContext ?
                        onChange(
                            { translation: (e.target as HTMLInputElement).value, language: selectedLanguage.value },
                            TRANSLATION_VALUE_CHANGED,
                            optionIndex
                        )
                    :   onChange(isLevelNameTranslation ? LEVEL_NAME_TRANSLATION_KEY : LEVEL_DESCRIPTION_TRANSLATION_KEY, {
                            translation: (e.target as HTMLInputElement).value,
                            language: selectedLanguage.value,
                        })
                }
                value={determineTranslationValue(translation, selectedLanguage, originalValue)}
                testId={`translations-input${optionIndex}`}
            />
        </TranslationFormWrapper>
    );

    useEffect(() => {
        const languages = Object.entries(TRANSLATIONS).map(entry => ({
            value: entry[0],
            label: entry[1],
        }));
        setLanguages(languages);
    }, [locale]);

    return (
        <TranslationsWrapper>
            <Label>Language</Label>
            {provided ?
                <NonDraggableWrapper provided={provided}>{renderTranslationForm()}</NonDraggableWrapper>
            :   renderTranslationForm()}
            <SelectDescription>{TRANSLATIONS_LANGUAGE_SELECT_DESCRIPTION}</SelectDescription>
        </TranslationsWrapper>
    );
};

export default Translations;
